import rules from '../secrets-web/src/config/rules';

export default {
  ...rules
};
